import React, { useState, Fragment } from "react";

//import Navigation from "./navigation";
import Footer from "./footer";
import Metabase from "./monitor/metabase";

const Graficos =  ({ setAuth, setRole }) => {

  const [role, setUno] = useState("a1");
  //const [activo, setActivo] = useState("graficosA"); //15-06-2022 //16abril2025

  return (
    <Fragment>
      {/*<Navigation setAuth={setAuth} role={role} setRole={setRole} activo={activo}/>*/}
      {/*EX 16-10-2026: el contenido va DENTRO de <div className="main">, que es lo que hace que el pie
         quede pegado al fondo. Es el patron de las otras pantallas (inicio.js, expediente.js): .container_todo
         es flex column con min-height:100vh, .main es flex:1 1 auto (index.css:208) y el <Footer/> va
         HERMANO de .main, no adentro. Sin ese .main el pie caia justo despues del contenido: en la solapa 1
         no se notaba porque su iframe mide 800px y el contenido supera la pantalla, pero en las solapas
         2, 3 y 4 (600px) el pie quedaba en el medio de la pagina. Reportado por el usuario. */}
      <div className="main">
        <h4 className="mt-5 text-center">Gráficos</h4>
        <div>
          <Metabase />
        </div>
      </div>
      <Footer/>
    </Fragment>
  );
}

export default Graficos;